export default theme => ({
  loader: {
    margin: 14
  },
  fullScreen: {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    textAlign: "center",
    backgroundColor: "#fafafa",
    opacity: 0.6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  text: {
    fontWeight: "bold",
    fontSize: "1.5rem"
  }
});
